'use strict';

(function (window, $) {
    var $jwMyStorePicker = $('#jwsdw-searchMyStorePicker'),
        $storeServiceTemplate = $('.jwsdw-storeService-template');
    /**
     * Method to publish store event to mediator to trigger store picker
     * @param {boolean} locatePosition true if the picker should try to get the geo position of the user false otherwise
     * @param {string} [postalCodeOrCity] the postal code or city as string if it is not a search with geo position
     * @param {string} [service] if given filter by this service
     * @returns {void}
     */
    function publish (locatePosition, postalCodeOrCity, service) {
        var $fieldLabel = $jwMyStorePicker.find('.jws-formLabel'),
            $inputField = $jwMyStorePicker.find('input[name="postalCodeOrCity"]'),
            $errorMessage = $jwMyStorePicker.find('.jws-formErrorMessage'),
            data = {
                'level': 2,
                'service': service
            };

        $errorMessage.addClass('jws-hidden');
        $fieldLabel.removeClass('jws-formError');
        $fieldLabel.removeClass('jwsdw-formLabelValid');
        $inputField.removeClass('jws-formError');

        if (locatePosition) {
            data.locatePosition = true;
            data.postalCodeOrCity = null;
        } else if (postalCodeOrCity) {
            data.locatePosition = false;
            data.postalCodeOrCity = postalCodeOrCity;
        } else {
            $errorMessage.removeClass('jws-hidden');
            $fieldLabel.addClass('jws-formError');
            $inputField.addClass('jws-formError');
            return;
        }

        window.jwsdwMediator.publish('openPicker', 'storePicker', data);
    }

    // Listeners

    // handle click on find button to open picker
    $(document).on('click', '#jwsdw-account-jwStore .jwsdw-searchMyStore-find', function () {
        window.jwsdwMediator.publish('openPicker', 'searchMyStorePicker', null);
    });

    // handle click on current location search button
    $(document).on('click', '.jwsdw-currentLocation', function () {
        var service = $('.jwsdw-jwStore-find').data('service');
        publish(true, null, service);
    });

    /**
     * @description Event handler for finding JW Store
     * @returns {void}
     */
    function findJWStore() {
        var service = $(this).data('service'),
            postalCodeOrCity = $('#jwsdw-loyalty-jwStore-postalCodeOrCity').val();
        publish(false, postalCodeOrCity, service);
    }
    // handle click on find button
    $(document).on('click', '.jwsdw-jwStore-find', findJWStore);
    $(document).on('keydown', '#jwsdw-account-jwStore input[name="postalCodeOrCity"]', function(e) {
        var keyCode = e.keyCode || window.event.keyCode;

        // keyCode 13 is ENTER
        if (keyCode === 13 && !e.originalEvent.repeat) {
            e.preventDefault();
            e.stopPropagation();
            findJWStore.call(document.querySelector('#jwsdw-account-jwStore'));
        }
    });

    // handle enter key presses in input field for postal code or city
    $jwMyStorePicker.on('keydown', 'input[name="postalCodeOrCity"]', function(e) {
        var keyCode = e.keyCode || window.event.keyCode;

        // keyCode 13 is ENTER
        if (keyCode === 13 && !e.originalEvent.repeat) {
            e.preventDefault();
            findJWStore.call($jwMyStorePicker.find('.jwsdw-jwStore-select-container'));
            return false;
        }
    });

    $(document).on('click', '#jwsdw-account-jwStore .jwsdw-store-edit', function () {
        const $jwMyStore = $('#jwsdw-account-jwStore'),
            $myStoreForm = $('#jwsdw-jwStore-form'),
            $storeIdField = $myStoreForm.find('#jwsdw-jwStore-form-storeId'),
            params = {
                'addressId': ''
            };

        params[window.jwsdwSettings.csrfTokenName] = window.jwsdwSettings.csrfTokenValue;

        $storeIdField.val('');
        $jwMyStore.find('.jwsdw-jwStore-container, #jwsdw-loyalty-storeDetailsBtn, .jwsdw-jwStore-container .jwsdw-address-preferred').addClass('jws-hidden');
        $jwMyStore.find('#jwsdw-jwStore-form, .jwsdw-searchMyStore-select-container').removeClass('jws-hidden');
        $('#jwsdw-loyalty-jwStore-preferredAddress-checkbox, #jwsdw-loyalty-jwStore-selected-preferredAddress-checkbox').prop('checked', false);

        // if store edit is part of a form, send form request
        if ($myStoreForm.length > 0) {
            // delete mystore
            $.ajax($myStoreForm.attr('action'), {
                'method': $myStoreForm.attr('method') || 'POST',
                'data': params,
                'error': deleteMyStoreErrorCallback
            });
        }
    });

    /**
     * @description ERROR callback
     * @returns {void}
     */
    function deleteMyStoreErrorCallback () {
        //todo
    }

    // listen to mediator event when user selects a store in picker and write data of selected store back to form
    window.jwsdwMediator.subscribe('storePickerSelectStore', function(data) {
        const $jwMyStore = $('#jwsdw-account-jwStore'),
            $myStoreForm = $('#jwsdw-jwStore-form'),
            $storeIdField = $myStoreForm.find('#jwsdw-jwStore-form-storeId'),
            store = data.store,
            $preferredAddress = $jwMyStorePicker.find('#jwsdw-loyalty-jwStore-preferredAddress-checkbox'),
            $storeCard = $jwMyStore.find('.jwsdw-store-card');

        // show store card with data of selected store
        $storeCard.find('.jwsdw-store-address1').text(store.address1);
        $storeCard.find('.jwsdw-store-address2').text(store.address2);
        $storeCard.find('.jwsdw-store-postalCode-city').text(store.postalCode + ' ' + store.city);
        $storeCard.find('.jwsdw-store-country').text(store.countryName);

        $('#jwsdw-loyalty-storeDetailsBtn').attr('href', '/store/' + store.id);
        $('#jwsdw-loyalty-storeDetailsBtn').attr('data-store-id', store.id);
        $storeIdField.val(store.id);
        data.preferredAddress = $preferredAddress.is(':checked');

        if (data.preferredAddress) {
            // show preferred address flag
            $('#jwsdw-jwStore-form, .jwsdw-address-preferred').addClass('jws-hidden');
            $jwMyStore.find('.jwsdw-address-preferred').removeClass('jws-hidden');
        }

        // if store search is part of a form, send form request
        if ($myStoreForm.length > 0) {
            //set myStore backend
            $.ajax($myStoreForm.attr('action'), {
                'method': $myStoreForm.attr('method') || 'POST',
                'data': $myStoreForm.serialize() + '&preferredAddress=' + data.preferredAddress,
                'error': setMyStoreErrorCallback,
                'success' : function () {
                    showStoreCard(store);
                }
            });
        } else {
            showStoreCard(store);
        }
    });

    /**
     * @description Method to show store card with promotions
     * @param {Object} store store object
     * @returns {void}
     */
    function showStoreCard (store) {
        const $jwMyStore = $('#jwsdw-account-jwStore'),
            $storeContainer = $jwMyStore.find('.jwsdw-searchMyStore-select-container'),
            $storeCardContainer = $jwMyStore.find('.jwsdw-jwStore-container'),
            $storeServices = $('.jwsdw-preferredStore-storeServices'),
            storePromotions = store.promotions || [],
            storeServices = store.services || [],
            storePromos = storePromotions || [];

        $('#jwsdw-loyalty-storeDetailsBtn').removeClass('jws-hidden');
        $storeCardContainer.removeClass('jws-hidden');
        $storeContainer.addClass('jws-hidden');

        $storeServices.html('');

        if (storePromos.length > 0) {
            storePromos
                .forEach(function(promo) {
                    var $service = $storeServiceTemplate.clone();

                    $service.find('.jws-iconList-text').text(promo.name);
                    $service.removeClass('jws-hidden').appendTo($storeServices);
                });
        }
        if (storeServices.length > 0) {
            storeServices
                .sort(function (a) {
                    return a.id === 'jackWolfskinCard' ? 1 : -1;
                })
                .forEach(function(service) {
                    var $service = $storeServiceTemplate.clone();

                    if (service.id === 'jackWolfskinCard') {
                        $service.find('.jws-iconList-text').html(window.app.resources.jackWolfskinCard);
                    } else {
                        $service.find('.jws-iconList-text').text(service.name);
                    }
                    $service.removeClass('jws-hidden').appendTo($storeServices);
                });
        }
    }

    $(document).on('change', '#jwsdw-loyalty-jwStore-selected-preferredAddress-checkbox', function() {
        if ($(this).is(':checked')) {
            const $myStoreForm = $('#jwsdw-jwStore-form');
            // show preferred address flag
            $.ajax($myStoreForm.attr('action'), {
                'method': $myStoreForm.attr('method') || 'POST',
                'data': $myStoreForm.serialize() + '&preferredAddress=true',
                'success': function() {
                    $('#jwsdw-jwStore-form, .jwsdw-address-preferred').addClass('jws-hidden');
                    $('#jwsdw-account-jwStore').find('.jwsdw-address-preferred').removeClass('jws-hidden');
                    $('.jwsdw-account-pickupLocation').data('isPreferred', false);
                },
                'error': setMyStoreErrorCallback
            });
        }
    });

    /**
     * @description ERROR callback
     * @returns {void}
     */
    function setMyStoreErrorCallback () {
        //todo
    }
}(window, jQuery));

/**
 * Store Services
 */
(function (window, $) {
    $(document).on('click', '#jwsdw-loyalty-storeServices', function() {
        $.ajax({
            'url': window.jwsdwSettings.baseUrl + '/Store-getStore',
            'method': 'GET',
            'data': {
                'storeId': $('#jwsdw-jwStore-form-storeId').val()
            },
            'success' : function (response) {
                window.jwsdwMediator.publish('openPicker', 'storeServicesPicker', {
                    'services': response.services,
                    'promotions': response.promotions
                });
            }
        });
    });
}(window, jQuery));
